import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider, useQuery } from '@apollo/client'
import client from '../client'
import fetchProjects from '../queries/project-list'
import ShareProject from '../components/share-project'
import ProjectRow from '../components/project-row'

const ProjectsTableHead = ({ isShared }) => {
  return (
    <thead>
      <tr>
        <th>
          <div>ReflEQ Name</div>
        </th>
        <th>
          <div>Created On</div>
        </th>
        <th>
          <div>Group(s)</div>
        </th>
        <th>
          <div>Students</div>
        </th>
        <th>
          <div>Questions</div>
        </th>
        <th>
          <div>{isShared ? 'Shared By' : 'Shared With'}</div>
        </th>
        <th>
          <div />
        </th>
        <th>
          <div />
        </th>
      </tr>
    </thead>
  )
}

const ProjectsTable = ({ projects, isShared, toggleShareProject }) => {
  if (projects && projects.length > 0) {
    return (
      <table className="fancy">
        <ProjectsTableHead isShared={isShared} />
        <tbody>
          {projects &&
            projects.map((p) => (
              <ProjectRow
                key={p.id}
                data={p}
                isShared={isShared}
                toggleShareProject={toggleShareProject}
              />
            ))}
        </tbody>
      </table>
    )
  } else {
    return <p>No projects yet</p>
  }
}

const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

function ProjectList() {
  const urlTab = getQueryVariable('tab')
  const [toShareProject, setToShareProject] = React.useState(null)
  const [shareModalOpen, setShareModalOpen] = React.useState(false)
  const [activeTab, setActiveTab] = React.useState(urlTab || 'my-refleqs')
  const { loading, error, data, refetch } = useQuery(fetchProjects)

  const toggleShareProject = (project) => {
    setToShareProject(project)
    setShareModalOpen(!shareModalOpen)
  }

  const onCancel = () => {
    toggleShareProject(null)
  }

  const afterShare = () => {
    refetch()
  }

  const showTab = (tabName) => {
    setActiveTab(tabName)
  }

  const renderTabControl = (tabName, tabDisplayName) => {
    let className = ''

    if (activeTab === tabName) {
      className = 'active'
    }

    return (
      <a className={className} onClick={() => showTab(tabName)}>
        {tabDisplayName}
      </a>
    )
  }

  if (!data) return

  return (
    <div className="project-list">
      <nav className="tabbed-subnav" role="navigation">
        <div className="container">
          {renderTabControl('my-refleqs', 'My ReflEQs')}
          {renderTabControl('shared-refleqs', 'Shared With Me')}
        </div>
      </nav>
      <div className="container">
        {activeTab === 'my-refleqs' && (
          <ProjectsTable
            projects={data.projects}
            toggleShareProject={toggleShareProject}
          />
        )}
        {activeTab === 'shared-refleqs' && (
          <ProjectsTable
            projects={data.sharedProjects}
            toggleShareProject={toggleShareProject}
            isShared
          />
        )}
        <ShareProject
          project={toShareProject}
          isOpen={shareModalOpen}
          onCancel={onCancel}
          afterShare={afterShare}
        />
      </div>
    </div>
  )
}

const projectList = document.getElementById('project-list')
if (projectList) {
  const root = createRoot(projectList)
  root.render(
    <ApolloProvider client={client}>
      <ProjectList />
    </ApolloProvider>
  )
}
